import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IUserState } from '../../state/user.state';
import { FeatureFlagsState } from '../reducers/feature-flags-reducer';

export const getUserState = createFeatureSelector<IUserState>('user');

export const getFeatureFlagsState = createSelector(
  getUserState,
  (state: IUserState) => state.featureFlags
);

export const getFeatureFlags = createSelector(
  getFeatureFlagsState,
  (state: FeatureFlagsState) => state.featureFlags
);
